import React from 'react'

const Logout = ()=>(
    <h1>You are Logged out</h1>
)

export {Logout}